module.exports = __webpack_public_path__ + "static/media/bulk_master_gst.a254fe52.csv";